/**
 * Format Twitter thread data for copying as Markdown
 */
export const formatTwitterCopy = (data: any): string => {
  if (!data || !data.tweets) {
    return 'No Twitter content available';
  }

  const sections: string[] = [];

  // Header
  const contentType = data.content_type || 'thread';
  sections.push(
    `## ${contentType.charAt(0).toUpperCase() + contentType.slice(1)} (${data.tweets.length} ${
      data.tweets.length === 1 ? 'tweet' : 'tweets'
    })`,
  );
  sections.push('');

  // Individual tweets
  const tweets = data.tweets.map((tweet: any) => {
    const tweetParts: string[] = [];

    // Tweet indicator
    tweetParts.push(
      `### Tweet ${tweet.position}/${data.tweets.length}${
        tweet.thread_indicator ? ' • ' + tweet.thread_indicator : ''
      }`,
    );
    tweetParts.push('');

    // Content
    tweetParts.push(tweet.content);
    tweetParts.push('');

    // Hashtags
    if (tweet.hashtags && tweet.hashtags.length > 0) {
      tweetParts.push(tweet.hashtags.map((tag: string) => `#${tag}`).join(' '));
      tweetParts.push('');
    }

    // Metadata
    const metadata: string[] = [];
    if (tweet.tone) {
      metadata.push(`**Tone:** ${tweet.tone}`);
    }
    if (tweet.content) {
      const remaining = 280 - tweet.content.length;
      metadata.push(`**Chars:** ${remaining}`);
    }
    if (metadata.length > 0) {
      tweetParts.push(metadata.join(' • '));
    }

    return tweetParts.join('\n');
  });

  sections.push(tweets.join('\n\n---\n\n'));

  return sections.join('\n');
};
